$(function() {
    const optionsList = $('.js-options');

    $('.js-show-filters').on('click', function showFilters() {
        $(this).addClass('is-open');
        $('.js-filters').addClass('is-open');
        $('body').addClass('is-filters-opened');
    });

    $(document).click( function closeBlocks(e) {
        const filtersCheck = $(e.target)
            .closest('.category-filters__field-list').length;
        const filtersBtnCheck = $(e.target).closest('.js-show-filters').length;
        const closeFiltersBtn = $(e.target).closest('.js-close-filters').length;

        if (!filtersCheck && !filtersBtnCheck || closeFiltersBtn) {
            $('.js-filters').removeClass('is-open');
            $('.js-show-filters').removeClass('is-open');
            $('body').removeClass('is-filters-opened');
        }
    });

    $(document).scroll(function() {
        const scrolled = $(document).scrollTop();
        const $filtersBlock = $('.js-category-filters');

        if (!$($filtersBlock).length) return;

        const filtersIndent = $($filtersBlock).offset().top;

        if (scrolled !== filtersIndent) {
            $('.js-category-filters').removeClass('is-show');
            return;
        }

        $('.js-category-filters').addClass('is-show');
    });

    $('button[type="reset"]').on('click', function() {
        const $form = $(this).closest('.js-form');

        $($form).find('.checkbox-label').removeClass('is-checked');
    });

    $('.js-options').on('click', '.js-filters-more-show', function showMore() {
        const $checkboxesWrap = $(this).siblings('.js-checkboxes-toggle-wrap');
        let $checkboxList = $(this).siblings('.js-checkbox-label');

        if ($($checkboxesWrap).length) {
            $checkboxList = $checkboxesWrap;
        } else if (!$($checkboxList).length) {
            $checkboxList = $(this).siblings('div').find('.js-checkbox-label');
        }

        if ($(this).hasClass('is-open')) {
            $(this).removeClass('is-open');
            $($checkboxList).removeClass('is-show');

            return $(this).text('Show ' + $(this).val() + ' more');
        }

        $(this).addClass('is-open');
        $($checkboxList).addClass('is-show');

        return $(this).text('Hide ' + $(this).val());
    });

    addShowMore(optionsList);

    function addShowMore(inputArray) {
        let checkboxList = [];

        for (let i = 0; i < inputArray.length; i++) {
            checkboxList = $(inputArray[i]).find('.js-checkbox-list');

            if (!checkboxList.length) {
                addBtnMore(inputArray[i], '.js-checkbox-label');

                continue;
            }

            addBtnMore(inputArray[i], '.js-checkbox-list');

            for (let j = 0; j < checkboxList.length; j++) {
                addBtnMore(checkboxList[j], '.js-checkbox-label', 'category-filters-more__btn_multi');
            }

            checkboxList = [];
        }
    }

    function addBtnMore(inputArray, className, classUpdate = '') {
        const array = $(inputArray).find(className);
        const elemCounts = array.length - 5;

        if (elemCounts < 1) return;

        const showMoreBtn = $('<button class="category-filters-more__btn js-filters-more-show '
            + classUpdate
            + '" value="' + elemCounts
            + '" type="button">Show ' + elemCounts + ' more</button>');

        $(inputArray).append(showMoreBtn);
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/category/filters.js